"use client";

import { useReportPageLoading } from "@/lib/hooks/useReportPageLoading";

/** Marks the app busy while Next.js shows a route Suspense fallback. */
export function PageLoadingReporter() {
  useReportPageLoading(true);
  return null;
}
